import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col content-overview-page__tiles-listings__column col-12 col-md-3" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  class: "row g-0",
  style: {"height":"100%"}
}
const _hoisted_4 = { class: "col column align-self-end" }
const _hoisted_5 = { class: "container-fluid tile-upper-lower" }
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-12 tile-upper-lower__upper" }
const _hoisted_8 = { class: "col col-12 tile-upper-lower__lower" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "container-fluid image-and-content-tile__button-container" }
const _hoisted_11 = { class: "row g-0 justify-content-end" }
const _hoisted_12 = { class: "col col-auto" }
const _hoisted_13 = { class: "image-and-content-tile__button" }
const _hoisted_14 = {
  class: "button button--icon button--round button--filled",
  type: "button"
}

import TressResponsivePicture from "@/components/TressResponsivePicture.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressContentTile',
  props: {
  tile: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: __props.tile.url
    }, [
      _createElementVNode("div", {
        class: "container-fluid g-0 tile image-and-content-tile category-listing-blue category-listing-blue--no-bg-color",
        style: _normalizeStyle([{"height":"100%"}, { backgroundColor: '#' + __props.tile.backgroundColor }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(TressResponsivePicture, {
                    pictures: __props.tile.image,
                    class: "image-and-content-tile__image"
                  }, null, 8, ["pictures"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "image-and-content-tile__header",
                    style: _normalizeStyle({ color: '#' + __props.tile.textColor }),
                    innerHTML: __props.tile.header
                  }, null, 12, _hoisted_9),
                  _createElementVNode("p", {
                    class: "image-and-content-tile__content",
                    style: _normalizeStyle({ color: '#' + __props.tile.textColor })
                  }, _toDisplayString(__props.tile.description), 5),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", _hoisted_14, [
                            _createVNode(_component_icon_arrow_right)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 4)
    ], 8, _hoisted_2)
  ]))
}
}

})